export default "__VITE_ASSET__$ni7eP6p__"